import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import Select from 'react-select';

import Nav from './components/nav/nav.js';
import Hero from './components/hero/hero.js';
import Filter from './components/filter/filter.js';
import ItemListCard from './components/item/itemListCard/itemListCard.js';
import DetailModal from './components/item/itemDetailModal/itemDetailModal.js';
import Footer from './components/footer/footer.js';
import FilterConstants from './constants/filter.js';

import createHistory from 'history/createBrowserHistory';
import FlipMove from 'react-flip-move';
import max1 from './images/patterns/max1.jpg';
import max5 from './images/patterns/max5.jpg';
import xtraGreen from './images/patterns/xtra-green.jpg';
import xtraColors from './images/patterns/xtra-pink.jpg';
import xtra from './images/patterns/xtra-pink.jpg';

import itemData from './items.json';

const sizesToPrices = (size) => {
  var priceStr = size.price;
  priceStr = priceStr.replace('$', '');
  return Number(priceStr);
};

class RTChooser extends React.Component {
  constructor() {
    super();
    
    const patternMap = {
      'EDGE': 'EDGE',
      'MAX-1XT': 'MAX-1XT',
      'MISC': 'MISC'
    };

    this.featuredItemIDs = [
      'T3XTRA',
      'T8MAX-1XT',
      '791020430XTRA',
      'T9XTRA',
      'P15XTRA',
      'T20XTRA',
      'T14MAX-1XT'
    ];

    this.allItems = itemData.map((i) => {
      i.pattern = patternMap[i.pattern];
      return i;
    });

    for (let i = 0; i < this.featuredItemIDs.length; i++) {
      let j = 0;
      for (j = 0; j < this.allItems.length; j++) {
        if (this.allItems[j].ID === this.featuredItemIDs[i]) {
          break;
        }
      }
      if (j < this.allItems.length) {
        let temp = this.allItems[i];
        this.allItems[i] = this.allItems[j];
        this.allItems[j] = temp;
      }
    }

    this.items = this.allItems;

    this.history = createHistory();
    var currentItemID = null;
    if(this.history && this.history.location.pathname) {
      var item = this.itemForItemID(this.history.location.pathname.substr(1));
      if(item) {
        currentItemID = item.ID;
      }
    }

    this.state = {
      currentItemID: currentItemID,
      gameTypeFilter: null,
      genderTypeFilter: null,
      sizeFilter: null,
      patternFilter: null,
      sort: FilterConstants.sortName,
      itemsAnimating: false
    };

    this.history.listen((location) => {
      this.setState(location.state);
    });

    this.animationDurationMS = 200;
    this.filterInteractionDelay = 500;
  }

  idFromSizes(sizes) {
    if(!sizes || !Array.isArray(sizes) || sizes.length === 0 || !sizes[0].walmartID) {
      return null;
    }

    return sizes[0].walmartID;
  }
  
  priceStringFromSizes(sizes) {
    if(!sizes || !Array.isArray(sizes)) {
      return '';
    }

    const prices = sizes.map(sizesToPrices);
    prices.sort();
    if(prices[0] < prices[prices.length-1]) {
      return '$' + prices[0].toFixed(2) + ' - ' + prices[prices.length-1].toFixed(2);
    } else {
      return '$' + prices[0].toFixed(2);
    }
  }

  setStateAndHistory(state, url) {
    this.setState(state);
    this.history.push(url, state);
  }

  updateItems(state) {
    const sortedItems = this.allItems.sort((a, b) => {      
      if(state.sort === FilterConstants.sortName) {
        if(a.description > b.description) {
          return 1;
        }
        if(b.description > a.description) {
          return -1;
        }

        return 0;
      } else if(state.sort === FilterConstants.sortPriceLowHigh) {
        const aPrices = a.sizes.map(sizesToPrices);
        
        const bPrices = b.sizes.map(sizesToPrices);
        aPrices.sort();
        bPrices.sort();
        const aLow = aPrices[0];
        const bLow = bPrices[0];

        if(aLow > bLow) {
          return 1;
        }
        if (bLow > aLow) {
          return -1;
        }
        return 0;
      } else if(state.sort === FilterConstants.sortPriceHighLow) {
        const aPrices = a.sizes.map(sizesToPrices);
        const bPrices = b.sizes.map(sizesToPrices);
        aPrices.sort();
        bPrices.sort();
        const aHigh = aPrices[aPrices.length-1];
        const bHigh = bPrices[bPrices.length-1];

        if(bHigh > aHigh) {
          return 1;
        }
        if (aHigh > bHigh) {
          return -1;
        }
        return 0;
      }
      return 0;
    });
    for (let i = 0; i < this.featuredItemIDs.length; i++) {
      let j = 0;
      for (j = 0; j < sortedItems.length; j++) {
        if (sortedItems[j].ID === this.featuredItemIDs[i]) {
          break;
        }
      }
      if (j < sortedItems.length) {
        let temp = this.allItems[i];
        sortedItems[i] = sortedItems[j];
        sortedItems[j] = temp;
      }
    }
    this.items = sortedItems.filter((item) => {
      if(state.gameTypeFilter !== null) {
        const patterns = FilterConstants.patternByGame[state.gameTypeFilter];
        if(patterns.indexOf(item.pattern) === -1) {
          return false;
        }
      }
      if(state.genderTypeFilter !== null) {
        if(item.type !== state.genderTypeFilter) {
          return false;
        }
      }

      if(state.sizeFilter !== null && item.sizes) {
        var sizeFound = false;
        for(var i = 0; i < item.sizes.length; i++) {
          if(item.sizes[i].size === state.sizeFilter) {
            sizeFound = true;
            break;
          }
        }

        if(!sizeFound) {
          return false;
        }
      }

      if(state.patternFilter !== null) {
        if(item.pattern !== state.patternFilter) {
          return false;
        }
      }

      return true;
    });

  }

  componentWillUpdate(nextProps, nextState) {
    if(this.state.sort !== nextState.sort ||
    this.state.gameTypeFilter !== nextState.gameTypeFilter ||
    this.state.genderTypeFilter !== nextState.genderTypeFilter ||
    this.state.patternFilter !== nextState.patternFilter ||
    this.state.sizeFilter !== nextState.sizeFilter) {
      this.updateItems(nextState);
      this.setState({itemsAnimating: true});
      setTimeout(()=> {
        this.setState({itemsAnimating: false});
      }, this.filterInteractionDelay);
    }
  }

  itemForItemID(id) {
    if(!id) {
      return null;
    }
    for(var i in this.allItems) {
      if(this.allItems[i].ID === id) {

        return this.allItems[i];
      }
    }
  }

  render() {
    const state = this.state;
    const items = this.items.map((item) => {
      const id = item.ID;
      const name = item.description;
      const images = item.images;
      const thumb = item.thumbnail;
      const sizes = item.sizes;
      const altText = item.altText;
      const pattern = item.pattern;

      return (
        <ItemListCard
          key={id}
          id={id}
          name={name}
          images={images}
          thumb={thumb}
          priceRange={this.priceStringFromSizes(sizes)}
          altText={altText}
          pattern={pattern}
          select={() => this.setStateAndHistory({currentItemID: id}, '/' + id)}
        />
      );
    });

    const gameTypes = (state.patternFilter) ? FilterConstants.gameByPattern[state.patternFilter] : FilterConstants.allGame;
    const patterns = (state.gameTypeFilter) ? FilterConstants.patternByGame[state.gameTypeFilter] : FilterConstants.allPatterns;
    const sortOptions = [
      {value: FilterConstants.sortName, label: 'Sort by: Name'},
      {value: FilterConstants.sortPriceLowHigh, label: 'Sort by: Price Low'},
      {value: FilterConstants.sortPriceHighLow, label: 'Sort by: Price High'},
    ];

    const setFilter = (name, value) => {
      if(this.state.itemsAnimating) {
        return;
      }
      if(name !== 'sort' && this.state[name] === value) {
        value = null;
      }
      if(this.contentDiv) {
        const headerHeight = 50;
        if(this.contentDiv.offsetWidth > 992 && window.scrollY > this.contentDiv.offsetTop - headerHeight) {
          window.scroll(0, this.contentDiv.offsetTop - headerHeight);
        } 
      }
      var newState = {};
      newState[name] = value;
      this.setState(newState);
    };

    const filter = (
      <Filter
        gameTypes={gameTypes}
        patterns={patterns}
        setGameFilter={(game) => setFilter('gameTypeFilter', game)}
        setGenderTypeFilter={(genderType) => setFilter('genderTypeFilter', genderType)}
        setSizeFilter={(size) => setFilter('sizeFilter', size)}
        setPatternFilter={(pattern) => setFilter('patternFilter', pattern)}
        gameTypeFilter={state.gameTypeFilter}
        genderTypeFilter={state.genderTypeFilter}
        sizeFilter={state.sizeFilter}
        patternFilter={state.patternFilter}
      />
    );

    const itemCards = (
      <div className="items">
        <div>
          <div className='sort-container'>
            <Select
              name="sort-select"
              value={this.state.sort}
              options={sortOptions}
              onChange={(opt) => setFilter('sort', opt.value)}
              clearable={false}
              searchable={false}
              className="sort-select"
            />
          </div>
        </div>
        <div className="item-grid">
          <FlipMove staggerDurationBy="5" duration={this.animationDurationMS} easing="ease-in-out">
            {items}
          </FlipMove>
        </div>
      </div>
    );

    var modal = null;
    const currentItem = this.itemForItemID(this.state.currentItemID);
    if(currentItem) {
      console.log(`Current ID: ${JSON.stringify(currentItem)}`);
      const name = currentItem.description;
      const sizes = currentItem.sizes;
      const game = FilterConstants.gameByPattern[currentItem.pattern];
      const highlights = [currentItem.highlight1, currentItem.highlight2, currentItem.highlight3];
      const images = currentItem.images;
      const pattern = currentItem.pattern;
      modal = (
        <DetailModal 
          isOpen={true} 
          closeModal={() => this.setStateAndHistory({currentItemID: null}, '')}
          name={name}
          sizes={sizes}
          game={game}
          id={currentItem.ID}
          highlights={highlights}
          pattern={pattern}
          images={images}/>
      );
    }
    var patternClass = 'xtra';
    if(state.patternFilter) {
      patternClass = FilterConstants.heroPatternClass[state.patternFilter];
    }

    const chooser = (
      <div className="rt-chooser">
        <div id="preloader">
          <img src={max1} width="1" height="1" alt="Max 1" />
          <img src={max5} width="1" height="1" alt="Max 5" />
          <img src={xtraGreen} width="1" height="1" alt="Xtra Green" />
          <img src={xtraColors} width="1" height="1" alt="Xtra Colors" />
          <img src={xtra} width="1" height="1" alt="Xtra" />
        </div>
        <Nav />
        <div className="main">
          <Hero patternClass={patternClass}/>
          <div ref={(contentDiv) => { this.contentDiv = contentDiv; }} className='item-content'>
            <div className='filter-container'>
              {filter}
            </div>
            <div className='item-list'>
              {itemCards}
            </div>
          </div>
        </div>
        <Footer></Footer>
        {modal}
      </div>
    );
    return chooser;
  }
}

ReactDOM.render(<RTChooser />, document.getElementById('root'));

export default RTChooser;


// WEBPACK FOOTER //
// ./src/index.js